export default __webpack_public_path__ + "static/media/DSC_0521.e3dfa5d8.jpg";